@if (component) {
@for(item of component.items; track item) {
@if((item.components?.length ?? 0) > 0 || client.isCms) {
<expandable [expandableTitle]="item.title"
            [class.b-t]="$first"
            class="block">
    <icms-outlet [components]="item.components" />
</expandable>
}
}
}